import firebase from "firebase"
import "firebase/storage";

export const storage = firebase.initializeApp({
    "projectId": "anime-blog-10478",
    "appId": "1:179227509952:web:ec127ec48fd8fbfedf5925",
    "databaseURL": "https://anime-blog-10478.firebaseio.com",
    "storageBucket": "anime-blog-10478.appspot.com",
    "locationId": "us-central",
    "apiKey": "AIzaSyDa-_PD5eu_wEPvL3p4LhwSpaOFw4gZxck",
    "authDomain": "anime-blog-10478.firebaseapp.com",
    "messagingSenderId": "179227509952",
    "measurementId": "G-SC01NLFJKL"
  });


// WEBPACK FOOTER //
// ./src/firebase/index.js